import placeholder from "../../../../images/bg.jpg";

export const getCardThumb = (campaign) => {
  const first =
    campaign && campaign.contents_displays && campaign.contents_displays[0];
  const raw =
    (campaign && campaign.main_content_thumb) ||
    (first && (first.file_thumb || first.content_file)) ||
    "";
  return raw ? raw.replace(".mp4", "-00001.jpg") : placeholder;
};

export const getCategoryName = (category, lang) => {
  if (!category) return null;
  if (category.name) return category.name;
  const isEs = (lang || "").toLowerCase().indexOf("es") === 0;
  return isEs
    ? category.name_es || category.name_en || null
    : category.name_en || category.name_es || null;
};
